import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from '../Page';

function ReportsConversionsDashboardPage(): JSX.Element {
  const { t } = useTranslation();

  return <Page title={t('Conversions Dashboard')}>{null}</Page>;
}

export default ReportsConversionsDashboardPage;
